<section class="dashboard-upper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-uppercase text-center">
          {{ profileData?.business_name }}
        </h1>
      </div>
    </div>
  </div>
</section>

<div class="dashboard-mid">
  <div class="dashboard-left">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <h4 class="rf mb-3">Quick Action</h4>
        </div>
      </div>
    </div>    <div class="bg-black">
      <a data-toggle="modal" data-target="#bulkorder" class="cursor-pointer"><i class="fa fa-shopping-cart icon"></i>
        Bulk Order</a>
      <a routerLink="/my-account/my-product" *ngIf="helperService.canAddProducts(profileData)"><i class="fa fa-tag icon"></i>Add Products</a>
      <a  class="disabled" data-toggle="tooltip" *ngIf="!helperService.canAddProducts(profileData)" title="Please upgrade your plan to use this feature."><i class="fa fa-tag icon"></i>Add Products</a>
      <a routerLink="/suppliers" *ngIf="helperService.canManageSuppliers(profileData)"><i class="fa  fa-wrench icon"></i>Add Suppliers</a>
      <a class="disabled" data-toggle="tooltip" title="Please upgrade your plan to use this feature." *ngIf="!helperService.canManageSuppliers(profileData)" ><i class="fa  fa-wrench icon"></i>Add Suppliers</a>
      <a routerLink="/my-account/my-downloads" ><i class="fa fa-download icon"></i>Downloads</a>
      <a routerLink="/my-account/integration" *ngIf="helperService.canAccessAPIIntegration(profileData)"><i
          class="fa fa-code icon"></i>API integration</a>
      <a routerLink="/profile-dashboard" class="disabled" *ngIf="!helperService.canAccessAPIIntegration(profileData)"
        data-toggle="tooltip" title="Please upgrade your plan to use this feature."><i class="fa fa-code icon"></i>API
        integration</a>
      <a routerLink="/my-account/my-profile"><i class="fa fa-user icon"></i>Account Dashboard</a>
      <a routerLink="/my-account/account-settings"><i class="fa fa-gear icon"></i>Settings</a>
      
    </div>
  </div>
  <div class="dashboard-right">
    <div class="mb-3">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="rf ml-0 mb-0">Recent Orders</h4>
            <a routerLink="/my-account/my-invoices" class="mr-0 text-decoration text-black text-du">See All</a>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-table ">
      <div class="table-responsive">
        <table class="table details-table " *ngIf="myOrders?.length>0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Order No.</th>
              <th>Supplier</th>
              <th>Status</th>
              <th>Tracking No</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of myOrders">
              <td class="f-light">{{formatDate(order.created_at)}}</td>
              <td class="f-light">
                <a style="cursor: pointer;" (click)="redirectToOrderDetails(order.id)">#00000{{order.id}}</a>
              </td>
              <td class="f-light">{{order.business_name}}</td>
              <td>
                <span [class.text-success]="order.status === 3 || order.status === 2"
                  [class.text-warning]="order.status === 0 || order.status === 1"
                  [class.text-danger]="order.status === 4">
                  {{transformStatus(order.status) }}
                </span>
              </td>
              <td class="f-light">
                <a href="#">{{order.tracking_number}}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!--  -->
      <h3 class="alert alert-danger rf" *ngIf="myOrders?.length == 0">
        No Recent Orders
      </h3>
    </div>
  </div>
</div>

<div class="modal fade bulk-order-modal" id="bulkorder" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" #modalRef>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Bulk Order</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body border-0">
        <p class="mb-3">
          Have the product numbers from our catalog? Enter them below for a
          quicker shopping experience
        </p>
        <div class="alert alert-danger sku_error d-none" role="alert">
          <i class="fa fa-times-circle icon"></i>No Product Found for SKU : <strong>{{err_sku}}</strong>
        </div>
        <div class="quantity_errors">

        </div>
        <div class="bulk-order-modal-inner mt-4">
          <div class="bulk-order-modal-row" *ngFor="let order of bulkOrders; let i = index">
            <div class="custom-label">
              <div class="form-group">
                <input type="text" id="inputField-{{i}}" [(ngModel)]="order.sku" (keyup)="fetchBySKU($event, order.idx)"
                  required />
                <label for="inputField-{{i}}">SKU</label>
              </div>
            </div>
            <img class="sku_loader d-none"
              src="https://global.discourse-cdn.com/sitepoint/original/3X/e/3/e352b26bbfa8b233050087d6cb32667da3ff809c.gif">
            <span class="abs-delete-icon" (click)="removeFromOrders(order.idx)">✕</span>
            <div class="custom-label">
              <div class="input-group custom-adder custom-adder-rw position-relative">
                <input type="button" value="-" class="button-minus qtyelem" (click)="decrementQuantity(order.idx)"
                  [disabled]="order.quantity <= minQuantity" />
                <input type="number" step="1" [min]="minQuantity" [(ngModel)]="order.quantity" name="quantity-{{i}}"
                  class="quantity-field qtyelem" />
                <input type="button" value="+" class="button-plus qtyelem" (click)="incrementQuantity(order.idx)" />
                <label class="f-light">Quantity</label>
              </div>
            </div>
            <div class="d-flex flex-column product-description hidden">
              <div class="modal-product-box">
                <img [src]="order.imageUrl | baseImage | imagePath" alt="img" />
                <div class="d-flex flex-column">
                  <a href="/{{order.slug}}/{{order.sku}}" target="_blank"
                    class="text-du text-uppercase text-black">{{order.sku}}</a>
                  <p class="d-flex mb-0 align-items-center">
                    <span class="text-black-50">${{order.price}} MSRP</span>
                    <i class="fa fa-trash icon" (click)="removeFromOrders(order.idx)"></i>
                  </p>
                </div>
              </div>
              <div class="alert alert-danger mt-2 d-none" role="alert">
                <i class="fa fa-times-circle icon"></i> Quantity Not Available
              </div>
            </div>
          </div>
          <!-- <div class="bulk-order-modal-row d-none">
            <div></div>
            <div></div>
            <div class="alert alert-danger" role="alert">
              <i class="fa fa-times-circle icon"></i> Quantity is not available
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer d-flex">
        <button type="button" class="btn white-btn px-4 py-2 br-10" (click)="AddMore()">
          Add More
        </button>
        <button type="button" class="btn bg-black text-white px-4 py-2 br-10" (click)="AddToCart($event)">
          Add To Cart
        </button>
      </div>
    </div>
  </div>
</div>